import {
  Component,
  ElementRef,
  HostBinding,
  HostListener,
} from '@angular/core';
import { SharedService } from './services/shared.service';
import { UserService } from './services/user.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  @HostBinding('attr.theme') get getTheme() {
    const userTheme = this.userService.user?.colorTheme;
    const localTheme = window.localStorage.getItem('gleemo-color-theme');
    // if local theme is different than current user theme, store user theme locally
    if (userTheme && userTheme !== localTheme) {
      window.localStorage.setItem('gleemo-color-theme', userTheme);
    }
    return userTheme ? userTheme : localTheme ? localTheme : 'dark';
  }

  // listen to scroll and fire observable when it hits the bottom
  @HostListener('scroll', ['$event'])
  handleScroll(): void {
    const el = this.elRef.nativeElement;
    if (el.scrollTop + el.clientHeight === el.scrollHeight) {
      this.sharedService.scrollBottom.next();
    }
  }

  constructor(
    private userService: UserService,
    private sharedService: SharedService,
    private elRef: ElementRef
  ) {
    this.userService.listenToAuthChange();
  }
}
